import { AES, enc } from "crypto-js";
import config from "config/Config.js";

export const LocalStorage = {
  getItem: (key: string) => {
    let encrypted = localStorage.getItem(key);
    if (encrypted != null) {
      const decrypted = AES.decrypt(encrypted, config.ENC_KEY || "DefaultKey");
      return decrypted.toString(enc.Utf8);
    } else return null;
  },

  setItem: (key: string, value: string) => {
    localStorage.setItem(
      key,
      AES.encrypt(value, config.ENC_KEY || "DefaultKey").toString()
    );
  },

  removeItem: (key: string) => {
    localStorage.removeItem(key);
  },
};
